import React from "react"
import styled from "styled-components"
import { BGWrapper, H2, H3, HeadingWrapper } from "./UIStyle/UIstyle"
import { theme } from "./mixin"

import PositionAndWidth from "./PositionAndWidth"
import Decoration from "./Decoration"
import PartnerCard from "./PartnerCard"

import Banner1 from "@/common/assets/image/lucky-bag-2023/partner/KGBanner.webp"
import Banner2 from "@/common/assets/image/lucky-bag-2023/partner/beast.webp"
import Banner3 from "@/common/assets/image/lucky-bag-2023/partner/domhie.webp"
import Banner4 from "@/common/assets/image/lucky-bag-2023/partner/Norns.webp"
import Banner5 from "@/common/assets/image/lucky-bag-2023/partner/Kuaicher.webp"
import Banner6 from "@/common/assets/image/lucky-bag-2023/partner/ok.webp"

const partner_data = [
  {
    name: "野獸國行動商城",
    rewards: "1000元折價券",
    desc: "野獸國為歐美漫畫、電影產業領導品牌，擁有迪士尼、漫威、阿凡達、星際大戰、哈利波特、神偷奶爸、樂一通、DC、ULTRAMAN、LINE FRIENDS、BT21等國際知名品牌授權，將IP品牌及角色導入在零售新體驗、包羅萬象的商品種類、創新的展覽活動等，打造娛樂體驗平台。",
    link: "https://www.beast-kingdom.com.tw/?utm_source=kryptogo&utm_medium=campaignsite",
    img: Banner2,
    id: "toybox-partnerButton1"
  },
  {
    name: "東海模型",
    rewards: "200元折價券",
    desc: "上萬種日系/美系動漫模型，萬代、GOOD SMILE、壽屋TAMIYA...等知名模型品牌通通有！",
    link: "https://www.ehobby.com.tw/?utm_source=kryptogo&utm_medium=campaignsite",
    img: Banner3,
    id: "toybox-partnerButton2"
  },
  {
    name: "Norns",
    rewards: "100元折價券",
    desc: "Norns用禮物幫你傳遞美好心意，由norns Design Lab設計研發，將日常生活小物注入創意細膩設計。以輕鬆、悠活為核心理念，推出一系列卡通IP文具、創意小物及生活雜貨。旗下IP包含蠟筆小新、史努比、櫻桃小丸子、迪士尼、小熊維尼、三眼怪、奇奇蒂蒂、史迪奇、嚕嚕米等經典人氣卡通明星。希望帶給每個人滿滿的療癒感及生活樂趣 ♡ ♡ ♡期待為你傳遞幸福與驚喜，Make today Amazing！",
    link: "https://shop.norns.com.tw/?utm_source=kryptogo&utm_medium=campaignsite",
    img: Banner4,
    id: "toybox-partnerButton3"
  },
  {
    name: "快車肉乾",
    rewards: "100元折價券",
    desc: "快車肉乾位於台北南門市場，40多年來的堅持，您品嚐的到。家傳古早味醬油是調味法寶，值得懷念的台灣味。",
    link: "https://www.kuaiche.com.tw/?utm_source=kryptogo&utm_medium=campaignsite",
    img: Banner5,
    id: "toybox-partnerButton4"
  },
  {
    name: "歐可茶葉",
    rewards: "50元折價券",
    desc: "網路原創茶葉品牌，年銷百萬包。創新茶包設計，引領台灣沖泡茶飲文化。堅持使用天然原料，讓消費者更安心。",
    link: "https://www.oktea.tw/?utm_source=kryptogo&utm_medium=campaignsite",
    img: Banner6,
    id: "toybox-partnerButton5"
  }
]

export default function Partners() {
  return (
    <Wrapper id="PARTNERS" bg={theme.bgLinearDeepBottom}>
      <ContentWrapper>
        <BGWrapper>
          <PositionAndWidth
            d={{ width: "80%", t: "-0%", r: "10%" }}
            m={{ width: "100%", t: "%", r: "0%" }}
          >
            <Decoration type="starBG" animation="updown" time={12} delay={3} />
          </PositionAndWidth>

          {/* 星星裝飾 */}
          <PositionAndWidth
            d={{ width: "50%", t: "13%", r: "-28%" }}
            m={{ width: "50%", t: "13%", r: "-28%" }}
          >
            <Decoration
              type="blobman3"
              animation="updown"
              time={12}
              delay={3}
            />
          </PositionAndWidth>
          <PositionAndWidth
            d={{ width: "60%", b: "25%", r: "-30%" }}
            m={{ width: "60%", b: "25%", r: "-30%" }}
          >
            <Decoration
              type="blobman3"
              animation="updown"
              time={12}
              delay={3}
            />
          </PositionAndWidth>
          <PositionAndWidth
            d={{ width: "50%", b: "-0%", l: "-20%" }}
            m={{ width: "50%", b: "-0%", l: "-20%" }}
          >
            <Decoration
              type="blobman2"
              animation="updown"
              time={12}
              delay={3}
            />
          </PositionAndWidth>

          <PositionAndWidth
            d={{ width: "50%", t: "30%", l: "-20%" }}
            m={{ width: "50%", t: "30%", l: "-20%" }}
          >
            <Decoration type="circle" animation="updown" time={12} delay={3} />
          </PositionAndWidth>

          <PositionAndWidth
            d={{ width: "1%", t: "50%", r: "-0.5%" }}
            m={{ width: "3%", t: "50%", r: "-1.5%" }}
          >
            <Decoration type="Scircle" animation="updown" time={12} delay={9} />
          </PositionAndWidth>
          <PositionAndWidth
            d={{ width: "1.5%", b: "-0.75%", l: "40%" }}
            m={{ width: "3%", b: "-0%", l: "40%" }}
          >
            <Decoration type="Scircle" animation="updown" time={12} delay={2} />
          </PositionAndWidth>
        </BGWrapper>
        <HeadingWrapper>
          <H3 color={theme.CTAcolor}>PARTNERS</H3>
          <H2>參與品牌</H2>
        </HeadingWrapper>
        <CardsWrapper>
          <CardWrapper>
            <PartnerCard
              img={Banner1}
              title="KryptoGO"
              rewards="iPhone 14 , Apple Watch , iPad 10 , AirPods , Apple TV "
              desc="臺灣首屈一指的區塊鏈科技公司，致力消除 Web3 的高進入門檻，打造出兼顧資安與便利、僅須手機號碼便可使用的超級 Web3 Wallet。"
              buttonContent1="下載 KryptoGO"
              buttonLink1="https://kryptogo.page.link/q9gD"
              buttonContent2="前往官網"
              buttonLink2="https://www.kryptogo.com/tw"
              right
              id="toybox-partnerButtonKG2"
              id2="toybox-partnerButtonKG1"
            />
          </CardWrapper>
          {partner_data.map(({ name, rewards, desc, link, img }, index) => (
            <CardWrapper key={name}>
              <PartnerCard
                img={img}
                title={name}
                rewards={rewards}
                desc={desc}
                buttonContent2="前往官網"
                buttonLink2={link}
                right={index % 2 ? 1 : null}
                id={name}
              />
            </CardWrapper>
          ))}
        </CardsWrapper>
      </ContentWrapper>
    </Wrapper>
  )
}
const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  padding: 80px 60px 100px 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ bg }) => bg};
  @media (${theme.md}) {
    padding: 80px 20px 20px 20px;
  }
`
const ContentWrapper = styled.div`
  position: relative;
  display: flex;
  border-radius: 73px;
  width: 100%;
  max-width: 1400px;
  gap: 32px;
  padding: 80px 60px 60px 60px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media (${theme.xxl}) {
    padding: 80px 60px 200px 60px;
  }
  @media (${theme.xl}) {
    border-radius: 36px;
  }
  @media (${theme.lg}) {
    border-radius: 36px;
    padding: 60px 20px 60px 20px;
  }

  @media (${theme.md}) {
    padding: 60px 0px 60px 0px;
    gap: 36px;
  }
`
const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  gap: 60px;
  @media (${theme.xxl}) {
    grid-template-columns: 1fr 1fr;
  }
  @media (${theme.lg}) {
    grid-template-columns: 1fr;
  }
  @media (${theme.md}) {
    gap: 30px;
  }
`
const CardWrapper = styled.div`
  width: 100%;
  @media (${theme.xxl}) {
    &:nth-child(2n) {
      transform: translate(0, 200px);
    }
    @media (${theme.lg}) {
      &:nth-child(2n) {
        transform: translate(0, 0px);
      }
    }
  }
`
